/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Wed July 10 2024
 **/

export const WEB_VIEW_FILE_PREVIEW_PROTOCOL = {
	CLOSE: 101,
	DOWNLOAD: 102,
	REMOVE: 103
} as const;

export type WEB_VIEW_FILE_PREVIEW_PROTOCOL =
	(typeof WEB_VIEW_FILE_PREVIEW_PROTOCOL)[keyof typeof WEB_VIEW_FILE_PREVIEW_PROTOCOL];
